/**
 * MD5 helpers — ported 1:1 from
 *   packages/amgsicbo_v2/lib/core/utils/md5_helper.dart
 */
import { md5 } from 'js-md5';

export function md5Hex(input: string): string {
  return md5(input);
}

/** MD5(agentId + gameKey + userName) — used for openGame/balance/placeBet. */
export function generateBalanceMd5(
  agentId: string,
  gameKey: string,
  userName: string,
): string {
  return md5Hex(`${agentId}${gameKey}${userName}`);
}

/** MD5(userName) — used for getInfo. */
export function generateInfoMd5(userName: string): string {
  return md5Hex(userName);
}
